@if (settingsReady$ | async) {
  <app-screen-shell
    [contentClass]="'container chat-settings-screen'"
    titleKey="chat.settings"
    (back)="goBack()">
    @if (canManageChat() || canLeaveChat() || canConfigureFootballerBot()) {
      <section class="chat-settings-actions">
        @if (canConfigureFootballerBot()) {
          <button type="button" class="chat-settings-row" (click)="toggleFootballerBot()" [disabled]="botSettingSaving">
            <span class="chat-settings-row-icon"><i [class]="'chat.automation' | nogoshIcon" aria-hidden="true"></i></span>
            <span class="chat-settings-row-copy">
              <strong>{{ 'chat.footballerBot' | translate }}</strong>
              <small>{{ (chat.footballerBotEnabled === false ? 'chat.footballerBotOff' : 'chat.footballerBotOn') | translate }}</small>
            </span>
            <span class="chat-settings-toggle" [class.is-on]="chat.footballerBotEnabled !== false" aria-hidden="true">
              <span></span>
            </span>
          </button>
        }
        @if (canManageChat()) {
          <button type="button" class="chat-settings-row" (click)="modifyChat()">
            <span class="chat-settings-row-icon"><i [class]="'common.edit' | nogoshIcon" aria-hidden="true"></i></span>
            <span class="chat-settings-row-copy"><strong>{{ 'chat.manage' | translate }}</strong></span>
          </button>
        }
        @if (canLeaveChat()) {
          <button type="button" class="chat-settings-row chat-settings-row-danger" (click)="showLeaveDialog = true">
            <span class="chat-settings-row-icon"><i [class]="'auth.logout' | nogoshIcon" aria-hidden="true"></i></span>
            <span class="chat-settings-row-copy"><strong>{{ 'chat.leave' | translate }}</strong></span>
          </button>
        }
      </section>
    }

    <section class="chat-settings-members">
      <div class="chat-settings-section-title">
        {{ 'chat.members' | translate }} · {{chat.players ? chat.players.length : 0}}
      </div>
      <div class="chat-settings-search-row">
        <div class="chat-settings-search">
          <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
          <input type="search" class="form-control" [(ngModel)]="memberFilter" [placeholder]="'chat.searchMembers' | translate" name="chatMemberFilter">
        </div>
        @if (canManageChatMembers()) {
          <button type="button" class="chat-settings-add-member" (click)="openAddMembers()" [attr.aria-label]="'chat.addMembers' | translate">
            <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
          </button>
        }
      </div>
      @for (player of filteredMembers(); track player.id) {
        <div class="chat-member-row">
          <button type="button" class="chat-member-profile" (click)="openPlayerDetail(player)">
            <div class="avatar-team chat-member-avatar" [style.backgroundImage]="player.avatar ? 'url(' + player.avatar + ')' : null">
              @if (!player.avatar) {
                <span>{{getPlayerInitials(player)}}</span>
              }
            </div>
            <div class="chat-member-copy">
              <strong>{{getPlayerDisplayName(player)}}</strong>
              @if (player.name && player.name !== player.nickName) {
                <span>{{player.name}}</span>
              }
              @if (chat.contact && player.id === chat.contact.id) {
                <span>{{ 'chat.admin' | translate }}</span>
              }
            </div>
          </button>
          <app-player-contact-actions [player]="player"></app-player-contact-actions>
          <button type="button" class="chat-member-chat" (click)="openPlayerDetail(player)">
            <i [class]="'common.chevronRight' | nogoshIcon" aria-hidden="true"></i>
            <span class="sr-only">{{ 'common.details' | translate }}</span>
          </button>
        </div>
      }
      @if (filteredMembers().length === 0) {
        <div class="chat-list-empty">{{ 'chat.noMembersFound' | translate }}</div>
      }
    </section>

    <app-dialog [(visible)]="showLeaveDialog" [closable]="false" class="app-dialog--confirm">
      <div class="modal-header">
        <h5 class="mb-0">{{ 'chat.leaveTitle' | translate }}</h5>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-secondary btn-sm px-3 text-white" (click)="showLeaveDialog = false">{{ 'common.no' | translate }}</button>
        <button type="button" class="btn btn-primary btn-sm px-3" (click)="leaveChat(); showLeaveDialog = false">{{ 'common.yes' | translate }}</button>
      </div>
    </app-dialog>
  </app-screen-shell>
}
